import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac451c34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chooseEquipment h-full flex flex-col" }
const _hoisted_2 = { class: "conent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-white font-medium" }, "选择机台", -1))
const _hoisted_4 = { class: "content_list content-start scrollBar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "top flex items-center justify-between" }
const _hoisted_7 = { class: "text-white font-medium title-text" }
const _hoisted_8 = { class: "bottom font-normal flex items-center justify-between" }
const _hoisted_9 = { class: "equipment" }
const _hoisted_10 = { class: "onLineStatu" }
const _hoisted_11 = {
  key: 0,
  class: "triangle"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/select.png",
  alt: ""
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_15 = { class: "footer flex justify-between items-center w-full text-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "model-content font-medium" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, "机台生产中"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white chooseTips" }, "选中机台正在生产中，是否继续选择？")
], -1))

import { ref, onMounted, reactive } from "vue";
import API, { IGetMachineTeamGetMachineBindListVo, IPostMachineTeamBindMachineBo } from "@/api/peopleTeam"
import router from "@/router/index";
import { storage } from "../constant/index"
import { logout, intoMain } from "@/constant/index";
//---------------------传入参数、回调、监听定义---------------------
//定义回调事件

export default /*#__PURE__*/_defineComponent({
  __name: 'chooseEquipment',
  emits: ['chooseClick'],
  setup(__props, { emit }) {



onMounted(() => {
    getList()
})
const createCreative = ref(null);
let activeIndedx: any = ref(storage.getMachineId('machineId') ? JSON.parse(JSON.stringify(storage.getMachineId('machineId'))).id : '')
const clickObj = ref<IGetMachineTeamGetMachineBindListVo>(storage.getMachineId('machineId') ? storage.getMachineId('machineId') : null)
const LoginUserId = ref(localStorage.getItem("userId"))
const userId = ref(storage.getTeamId('machineId') ? JSON.parse(JSON.stringify(storage.getTeamId('machineId'))).userId : '')
const visible = ref<boolean>(false);
let activeStyle: any = ref({
    borderWidth: "1px",
    borderStyle: 'solid',
    borderColor: '#13C2C2',
})
let parmas = reactive<IPostMachineTeamBindMachineBo>({
    machineId: undefined
})
let listData = ref<IGetMachineTeamGetMachineBindListVo[]>([])
const restActive = ref({
    background: ' #ED7B2F'
})
const freeActive = ref({
    background: '#5E5E5E'
})
// ---------------------方法定义-------------------------
const chooseEquipment = function (item) {
    if (!userId.value) {
        LoginUserId.value = userId.value
    }
    clickObj.value = item
    //选择生产中的机台弹出框确认
    if (item.state == 'producing') {
        visible.value = true;
        return
    }
    activeIndedx.value = item.id
    parmas.machineId = item.id
};
//弹框取消
const modelCancel = () => {
    visible.value = false;
    //回显上次选择的机台
    activeIndedx.value = JSON.parse(JSON.stringify(storage.getMachineId('machineId'))).id || ''
    clickObj.value = JSON.parse(JSON.stringify(storage.getMachineId('machineId'))) || ''
}
//弹框二次确认
const modelSure = () => {
    visible.value = false;
    activeIndedx.value = clickObj.value.id
    parmas.machineId = clickObj.value.id
}
//取消设备绑定
const cancel = () => {
    if (router.currentRoute.value.query && router.currentRoute.value.query.key) {
        intoMain()
    } else {
        logout()
    }
}
//进入班组绑定
const next = () => {
    storage.set('NewmachineId', clickObj.value)
    emit('chooseClick', true)
}
const getList = () => {
    API.getMachineTeamGetMachineBindList().then((res) => {
        listData.value = res.list
        if (storage.getMachineId('machineId') && JSON.parse(JSON.stringify(storage.getMachineId('machineId'))).id) {
            res.list.map(item => {
                if (item.id == JSON.parse(JSON.stringify(storage.getMachineId('machineId'))).id) {
                    parmas.machineId = JSON.parse(JSON.stringify(storage.getMachineId('machineId'))).id
                }
            })
        }

    })
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item flex flex-col justify-between",
              key: index,
              onClick: ($event: any) => (chooseEquipment(item)),
              style: _normalizeStyle(_unref(activeIndedx) == item.id && LoginUserId.value == userId.value ? _unref(activeStyle) : '')
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.machineName), 1),
                _createElementVNode("div", {
                  class: "statu text-white text-center font-normal",
                  style: _normalizeStyle(item.state == 'rest' ? restActive.value : item.state == 'free' ? freeActive.value : '')
                }, _toDisplayString(item.state == 'producing' ? '生产中' : item.state == 'rest' ? '休息' : '空闲'), 5)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, "绑定设备：" + _toDisplayString(item.equipmentName), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.online ? '在线' : '未连接'), 1)
              ]),
              (_unref(activeIndedx) == item.id && LoginUserId.value == userId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true)
            ], 12, _hoisted_5))
          }), 128)),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "btn cancle",
          onClick: cancel
        }, "取消"),
        _createVNode(_component_a_button, {
          type: "primary",
          class: "btn next",
          onClick: next,
          disabled: !(_unref(listData).length > 0 && _unref(parmas).machineId)
        }, {
          default: _withCtx(() => [
            _createTextVNode("下一步")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", {
      class: "create-creative",
      ref_key: "createCreative",
      ref: createCreative
    }, [
      _createVNode(_component_a_modal, {
        visible: visible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
        getContainer: () => createCreative.value,
        maskClosable: false,
        width: _ctx.$px2rem('540px'),
        centered: "",
        closable: false,
        "ok-text": "确认",
        "cancel-text": "取消"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", { class: "flex justify-between font-medium text-center" }, [
            _createElementVNode("div", {
              class: "modelBtn cancel",
              onClick: modelCancel
            }, "取消"),
            _createElementVNode("div", {
              class: "modelBtn sure text-white",
              onClick: modelSure
            }, "确定")
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["visible", "getContainer", "width"])
    ], 512)
  ], 64))
}
}

})